<template>
  <page title="App / Settings" size="is-desktop" :loading="loading">
    <setting-group title="Cache">
      <setting-item title="Clear cache /home/">
        <cache-clear tags="home">
          <button
            class="button"
            slot="trigger"
            slot-scope="{ processing }"
            :class="{ 'is-loading': processing }"
          >
            <span>Clear</span>
          </button>
        </cache-clear>
      </setting-item>
    </setting-group>
  </page>
</template>

<script>
import SettingGroup from "./../../../../components/layouts/settings/SettingGroup";
import SettingItem from "./../../../../components/layouts/settings/SettingItem";

import CacheClear from "./../../components/CacheClear";

export default {
  components: {
    CacheClear,
    SettingGroup,
    SettingItem
  }
};
</script>
